module.exports = __webpack_public_path__ + "media/images/icons/hamburger_menu-f2ede94be93034b2b08b909c197c8f89.svg";